<template>

    <div>
        <el-card shadow="hover"  class="searchCard" >
             <span class="label-span">
                <label class="label">岗位名称</label>
                <el-input v-model.trim="query.name" placeholder="岗位名称" class="handle-input mr10"></el-input>
            </span>
            <span class="label-span">
                <label class="label">岗位状态</label>
                <el-select v-model="query.status"  placeholder="岗位状态" clearable class="handle-select mr10">
                    <el-option value="" label="全部"  />
                    <el-option value="1" label="启用"  />
                    <el-option value="0" label="停用"  />
                </el-select>
            </span>
            <el-button icon="el-icon-search" class='mr10' @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" class='mr10' @click="refreshSearch">重置</el-button>
<!--            <el-dropdown class='mr10'>-->
<!--                <el-button  type="primary" >批量操作 v</el-button>-->
<!--                <el-dropdown-menu slot="dropdown">-->
<!--                        <span class='tableOperBtn2' @click="updateMore">-->
<!--                            <i class="el-icon-edit"></i> 批量修改-->
<!--                        </span> <br>-->
<!--                    <span class='tableOperBtn2' @click="deleteMore">-->
<!--                            <i class="el-icon-delete"></i> 批量删除-->
<!--                        </span>-->
<!--                </el-dropdown-menu>-->
<!--            </el-dropdown>-->
            <el-button icon="el-icon-lx-roundadd" class='mr10' @click="handleAdd" >添加岗位</el-button>



        </el-card>
        <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="name" min-width="160" align="left" label="岗位名称"> </el-table-column>
                <el-table-column prop="code" min-width="160" align="left" label="岗位编码"> </el-table-column>
                <el-table-column prop="detail" min-width="250" align="left" label="岗位描述">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:18px;">{{scope.row.detail}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="detail" min-width="100" align="left" label="提成模式">
                    <template slot-scope="scope" >
                        {{scope.row.ptype==1?"成本模式":scope.row.ptype==2?"利润模式":"-"}}
                    </template>
                </el-table-column>
                <el-table-column prop="pnum" min-width="80" align="left" label="提成比例">
                    <template slot-scope="scope" >
                        {{scope.row.pnum?scope.row.pnum + '%':"--"}}
                    </template>
                </el-table-column>

                <el-table-column prop="status" min-width="80" align="center" label="岗位状态">
                    <template slot-scope="scope" >
                        <el-tooltip :content="scope.row.status=='1'?'岗位已开启':'岗位已关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                       v-model="scope.row.status"
                                       active-color=""
                                       inactive-color=""
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" min-width="165" align="center"  label="创建时间"> </el-table-column>
                <el-table-column label="操作" min-width="180" align="center"  fixed="right">
                    <template slot-scope="scope">
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>

            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-card>
        <!-- 新建自主岗位弹出框 -->
        <el-dialog title="添加" :visible.sync="addVisible" :before-close="done=>handleAddClose(done,'form1')"
                   :modal-append-to-body='false' :close-on-click-modal="false" top="80px" width="500px">
            <el-form ref="form1" :rules="rules" :model="form1" label-width="80px">
                <el-form-item prop="name" label="岗位名称">
                    <el-input v-model.trim="form1.name"  placeholder="不超过10个字" class="w100"></el-input>
                </el-form-item>
                <el-form-item prop="code" label="岗位编码">
                    <el-input v-model.trim="form1.code"  placeholder="请输入岗位编码" class="w100"></el-input>
                </el-form-item>
                <el-form-item label="岗位描述">
                    <el-input type="textarea" v-model.trim="form1.detail"  placeholder="不超过50个字" class="w100"></el-input>
                </el-form-item>
                <el-form-item prop="ptype" label="提成模式" style="width:100%;display:inline-block;" >
                    <el-radio-group  v-model.trim="form1.ptype" >
                        <el-radio-button label="1">成本模式</el-radio-button>
                        <el-radio-button label="2">利润模式</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item required prop="pnum" label="提成比例" style="width:60%;display:inline-block;margin-top:-25px;" v-if="form1.ptype === '2'">
                    <el-input v-model.trim="form1.pnum" placeholder="请输入提成比例">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resetAddForm('form1')">取 消</el-button>
                <el-button type="primary" @click="saveForm('form1')">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>

        <!-- 编辑自主岗位弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible" :modal-append-to-body='false' :close-on-click-modal="false" top="50px" width="500px">
            <el-form ref="form2" :rules="rules" :model="form2" label-width="80px">
                <el-form-item prop="name" label="岗位名称">
                    <el-input v-model.trim="form2.name"  placeholder="不超过10个字" class="w100"></el-input>
                </el-form-item>
                <el-form-item prop="code" label="岗位编码">
                    <el-input disabled v-model.trim="form2.code"  placeholder="请输入岗位编码" class="w100"></el-input>
                </el-form-item>
                <el-form-item label="岗位描述">
                    <el-input type="textarea" v-model.trim="form2.detail"  placeholder="不超过50个字" class="w100"></el-input>
                </el-form-item>
                <el-form-item prop="ptype" label="提成模式" style="width:100%;display:inline-block;" >
                    <el-radio-group  v-model.trim="form2.ptype" >
                        <el-radio-button label="1">成本模式</el-radio-button>
                        <el-radio-button label="2">利润模式</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="pnum" label="提成比例" style="width:60%;display:inline-block;margin-top:-25px;" v-if="form2.ptype === '2'">
                    <el-input v-model.trim="form2.pnum" placeholder="请输入提成比例">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit('form2')">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="批量修改" :visible.sync="updateMoreVisible" :modal-append-to-body='false' :close-on-click-modal="false" top="50px" width="500px">
            <el-form ref="form" :model="form3" label-width="80px">
                <el-form-item required label="岗位名称">
                    <el-input v-model.trim="form3.name"  placeholder="不超过10个字" class="w100"></el-input>
                </el-form-item>
                <el-form-item required label="岗位内容">
                    <el-input  type="textarea" v-model.trim="form3.content"  placeholder="不超过50个字" class="w100"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateMoreVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveUdateMore">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,handDeleteMore,changeForm,changeStatus,handUpdateMore} from './comUserPer';
export default {
    data() {
        return {
            rules: {
                name: [
                    { required: true, message: '请填写岗位名称', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请填写岗位编码', trigger: 'blur' }
                ],
                ptype: [
                    { required: true, message: '请选择绩效分配', trigger: 'blur' }
                ],
                pnum: [
                    { required: true, message: '请输入提成比例', trigger: 'blur' },
                    { validator: this.validateNumber, trigger: 'blur' },
                ]
            },
            isSubmitting: false, // 是否正在提交
            select:{ option:'',  },
            query: {
                pageIndex: 1,
                pageSize: 10,
            },
            multipleSelection:[],
            tableData: [],
            pageTotal: 0,
            editVisible: false,
            addVisible: false,
            updateMoreVisible:false,
            form: {  },
            form1: {name:'',ptype:1,pnum:''},
            form2: {name:'',ptype:1,pnum:''},
            form3: {   },
            id: -1
        };
    },
    created() {

    },
    //页面加载方法
    mounted: function () {
        //查询列表
        this.getData();
    },

    methods: {
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){
            this.$set(this.query, 'name', '');
            this.$set(this.query, 'status');
            this.handleSearch();
        },
        //触发刷新按钮
        refresh(){
            history.go(0);
        },

        //查询
        getData(){
            this.multipleSelection = [];
            fetchData(this.query).then(res => {
                if(res.code=='200'){
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;
                }else{
                    this.tableData = [];
                    this.pageTotal = 0;
                }

            });
        },

        validateNumber(rule, value, callback) {
            if (!value) {
                callback(new Error('不能为空'));
            } else if (!/^\d+(\.\d{1})?$/.test(value)) {
                callback(new Error('必须是整数或小数点后一位'));
            } else if (parseFloat(value) < 0 || parseFloat(value) > 20) {
                callback(new Error('必须在0-20之间'));
            } else {
                callback();
            }
        },

        // 添加岗位
        handleAdd() {
            this.addVisible = true;
        },

        handleAddClose(done,formName) {
            this.resetAddForm(formName);
            done();
        },

        resetAddForm(formName) {
            this.addVisible = false;
            this.$refs[formName].resetFields();
        },
        //保存添加
        saveForm(formName) {
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.addVisible = false;
                    saveForm(this.form1).then(res => {
                        this.loading = false;
                        this.isSubmitting = false;
                        if(res.code=='200'){
                            this.addVisible = false;
                            this.$message.success(res.message);
                            this.refreshSearch();
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
                this.isSubmitting = false;
            });
        },

        // 编辑操作
        handleEdit(index, row) {
            this.editVisible = true;
            this.form2 = row;
        },
        // 保存更改
        saveEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    changeForm(this.form2).then(res => {
                        if(res.code=='200'){
                            this.editVisible = false;
                            this.$message.success(res.message);
                            this.refreshSearch();
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {
            var tips ;
            var content;
            if(row.status=='0'){
                row.status='1'
                tips = "禁用";
                content = "确定禁用吗？";
            }else{
                row.status='0'
                tips = "启用";
                content = "确定启用吗？";
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => {
                if(row.status=='0'){
                    row.status='1'
                }else{
                    row.status='0'
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){
                        this.$message.success(tips+'成功');
                        this.getData();
                    }else{
                        if(row.status=='0'){
                            row.status='1'
                        }else{
                            row.status='0'
                        }
                        this.$message.error(tips+'失败');
                    }
                });
            })
        },
        // 删除
        handDelete(index, row) {
            // 二次确认删除
            this.$confirm('该岗位所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){
                        this.$message.success('删除成功');
                        this.$set(this.query, 'pageIndex', 1);
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该岗位商品仍有订单未结算，请手动结算订单！");
                    }else{
                        this.$message.error("删除失败");
                    }
                });
            })
        },

        // 批量修改
        updateMore(){
            if(this.multipleSelection.length===0){
                this.$message.error("请勾选需要批量修改的数据");
                return;
            }
            this.updateMoreVisible = true;
        },
        saveUdateMore(){
            var ids = '';
            for (let i = 0; i < this.multipleSelection.length; i++) {
                ids += this.multipleSelection[i].id + ',';
            }
            this.form3.id = ids.substring(0,ids.length-1);
            this.updateMoreVisible = false;
            handUpdateMore(this.form3).then(res => {
                if(res.code=='200'){
                    this.$message.success('批量修改成功');
                    this.handleSearch();
                }else{
                    this.updateMoreVisible = true;
                    this.$message.error(res.message );
                }
            });
        },
        //批量删除
        deleteMore(){
            if(this.multipleSelection.length ===0){
                this.$message.error("请勾选需要批量删除的数据");
                return;
            }
            this.$confirm('确认要进行批量删除操作吗？', '提示', {
                type: 'warning'
            }).then(() => {
                var ids = '';
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    ids += this.multipleSelection[i].id + ',';
                }
                ids = ids.substring(0,ids.length-1);
                handDeleteMore({ id:ids }).then(res => {
                    if(res.code=='200'){
                        this.$message.success('批量删除成功');
                        this.handleSearch();
                    }else{
                        this.$message.error(res.message );
                    }
                });
            })

        },


        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val) {
            this.$set(this.query, 'pageSize', val);
            this.handleSearch();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
    }
};
</script>

<style scoped>

</style>
